var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2308 13.9245H20.3846V23.6176M18.2308 23.61H22.5385M3.15385 5.30307C2.58261 5.30307 2.03477 5.53001 1.63085 5.93396C1.22692 6.33792 1 6.88581 1 7.45709V26.8433C1 27.4146 1.22692 27.9625 1.63085 28.3664C2.03477 28.7704 2.58261 28.9973 3.15385 28.9973H26.8462C27.4174 28.9973 27.9652 28.7704 28.3692 28.3664C28.7731 27.9625 29 27.4146 29 26.8433V7.45709C29 6.88581 28.7731 6.33792 28.3692 5.93396C27.9652 5.53001 27.4174 5.30307 26.8462 5.30307H22.5385M7.46166 0.997314V9.61341M22.5384 0.997314V9.61341M7.46159 5.30307H18.2308M7.46159 13.9245H12.8462L9.61543 18.2326C9.61543 18.2326 12.8462 18.2326 12.8462 20.3866C12.907 20.8251 12.8653 21.2718 12.7244 21.6915C12.5836 22.1112 12.3473 22.4926 12.0343 22.8056C11.7213 23.1187 11.3399 23.3549 10.9203 23.4958C10.5006 23.6367 10.0539 23.6784 9.61543 23.6176H7.46159",
    stroke: "#AA1A5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.507a4c6d494ba7ee63cd88dcde411019.svg";
export { ForwardRef as ReactComponent };